// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Available namespaces for modular i18n structure
export const NAMESPACES = {
  COMMON: 'common',
  TRANSLATION: 'translation',
  AUTH: 'auth',
  CAMPAIGNS: 'campaigns',
  DRAWS: 'draws',
  ANNOUNCEMENTS: 'announcements',
  SURVEYS: 'surveys',
  BRANDS: 'brands',
  TENANTS: 'tenants',
  USERS: 'users',
  PAYMENTS: 'payments',
  DASHBOARD: 'dashboard',
  VIDEOS: 'videos',
  TICKETS: 'tickets',
  REPORTS: 'reports',
};

// Configure i18next
i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'tr'],
    fallbackLng: 'tr',
    debug: process.env.NODE_ENV === 'development',
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      cookieMinutes: 60 * 24 * 365, // 1 year
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'no-store'
      }
    },
    ns: [
      'common',
      'translation',
      'auth',
      'campaigns',
      'draws',
      'announcements',
      'surveys',
      'brands',
      'tenants',
      'users',
      'payments',
      'dashboard',
      'videos',
      'tickets',
      'reports',
    ],
    defaultNS: 'translation',
    fallbackNS: 'common',
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${key} for language: ${lng} in namespace: ${ns}`);
      }
    }
  });

export default i18n;
